import { useStaticCrud } from 'legacy/lut/hooks/useStaticCrud'
import { Table } from 'legacy/lut/library/list'
import { useSelector } from 'react-redux'

import { selectKeyObjectivesHierarchy } from '../../model'

import { STRATEGIC_INITIATIVES_TABLE_COLUMNS } from './configs'

export const StrategicInitiativesTable = () => {
  const keyObjectives = useSelector(selectKeyObjectivesHierarchy)

  const source = useStaticCrud({
    items: keyObjectives,
    keyField: 'key',
    hierarchyField: 'parent',
    hierarchyRoot: null,
  })

  return (
    <Table
      header
      hasHierarchy
      hasTranslate
      source={source}
      columns={STRATEGIC_INITIATIVES_TABLE_COLUMNS}
    />
  )
}

StrategicInitiativesTable.displayName = 'StrategicInitiativesTable'
